import type { GPLocaleObject } from '~/locales/types';

/**
 * @returns the current {@link GPLocaleObject} for accessing iso, language label, etc.
 */
export default () => {
  const { locales, locale } = useI18n();

  return computed(() =>
    (locales.value as GPLocaleObject[]).find(
      (l: GPLocaleObject) => l.code === locale.value,
    ),
  );
};
